/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UserAccessibleAppsResponse } from '../../models/user-accessible-apps-response';

export interface GetUserAccessibleApps$Params {
}

export function getUserAccessibleApps(http: HttpClient, rootUrl: string, params?: GetUserAccessibleApps$Params, context?: HttpContext): Observable<StrictHttpResponse<UserAccessibleAppsResponse>> {
  const rb = new RequestBuilder(rootUrl, getUserAccessibleApps.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<UserAccessibleAppsResponse>;
    })
  );
}

getUserAccessibleApps.PATH = '/api/v2/apps/access';
